module.exports = __webpack_public_path__ + "img/zfb.b4430680.png";